/** Aufrufe der Statusseite. */

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';

export type SystemStatus = components['schemas']['SystemStatus'];
export type VersionInfo = components['schemas']['VersionInfo'];
export type CheckState = components['schemas']['CheckState'];
export type ChangelogEntry = components['schemas']['ChangelogEntry'];
export type JobStatus = components['schemas']['JobStatus'];

export function fetchSystemVersion(): Promise<VersionInfo> {
  return request<VersionInfo>('/system/version');
}

export function fetchSystemStatus(): Promise<SystemStatus> {
  return request<SystemStatus>('/system/status');
}
